import { Controller } from "@hotwired/stimulus"
import AutoNumeric from "autonumeric"

// Actualiza el monto y el resumen de precios al cambiar el método de pago.
export default class extends Controller {
  static targets = [
    "method",
    "amount",
    "subtotal",
    "total",
    "agreementRow",
    "agreementDiscount",
    "bankRow",
    "bankDiscount",
    "agreementBanner"
  ]
  static values = { breakdowns: Object }

  connect() {
    this.updateFromSelectedMethod()
  }

  change() {
    this.updateFromSelectedMethod()
  }

  updateFromSelectedMethod() {
    if (!this.hasMethodTarget) return

    const key = this.methodTarget.value
    if (!key) return

    const breakdown = this.breakdownsValue[key]
    if (!breakdown) return

    this.updateAmount(breakdown.total)
    this.updateSummary(breakdown)
  }

  updateAmount(total) {
    if (!this.hasAmountTarget) return

    const autoNumeric = AutoNumeric.getAutoNumericElement(this.amountTarget)
    if (autoNumeric) {
      autoNumeric.set(total)
    } else {
      this.amountTarget.value = total
    }
  }

  updateSummary(breakdown) {
    if (this.hasSubtotalTarget) {
      this.subtotalTarget.textContent = breakdown.subtotal
    }

    if (this.hasTotalTarget) {
      this.totalTarget.textContent = breakdown.total_formatted
    }

    if (this.hasAgreementRowTarget) {
      this.agreementRowTarget.classList.toggle("hidden", !breakdown.show_agreement)
    }

    if (this.hasAgreementDiscountTarget && breakdown.show_agreement) {
      this.agreementDiscountTarget.textContent = `−${breakdown.agreement_discount}`
    }

    if (this.hasBankRowTarget) {
      this.bankRowTarget.classList.toggle("hidden", !breakdown.show_bank)
    }

    if (this.hasBankDiscountTarget && breakdown.show_bank) {
      this.bankDiscountTarget.textContent = `−${breakdown.bank_discount}`
    }

    if (this.hasAgreementBannerTarget) {
      if (breakdown.active_agreement && breakdown.agreement_banner) {
        this.agreementBannerTarget.textContent = breakdown.agreement_banner
        this.agreementBannerTarget.classList.remove("hidden")
      } else {
        this.agreementBannerTarget.classList.add("hidden")
      }
    }
  }
}
